import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';

export const getDebitNotes = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/debit-notes', filterParameters), getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { handleApiError(error); callback({ error }); }
};

export const fetchDebitNote = async (id, callback) => {
    try {
        const response = await risapi.get(`/api/debit-notes/${id}`, getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { handleApiError(error); callback({ error }); }
};

export const createDebitNote = async (newData, callback) => {
    try {
        const response = await risapi.post('/api/debit-notes', newData, getAxiosConfig());
        if (response.status === 201) callback(response.data);
    } catch (error) { callback({ error }); }
};

export const updateDebitNote = async (id, updateData, callback) => {
    try {
        const response = await risapi.put(`/api/debit-notes/${id}`, updateData, getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { callback({ error }); }
};

export const destroyDebitNote = async (id, callback) => {
    try {
        const response = await risapi.delete(`/api/debit-notes/${id}`, getAxiosConfig());
        if (response.status === 204) callback({ success: true });
    } catch (error) { callback({ error }); }
};